<template>
    <div class="waterfall justify-center w-full" ref="wallFall">
        <ImageVideoLoading
            v-for="(item, index) in fileList"
            :src="item.src"
            :item="item"
            :isLazy="isLazy"
            :isDisableMouseover="isDisableMouseover"
            :is-loop="isLoop"
            :is-auto-play="isAutoPlay"
            :controls="controls"
            :key="index + item.src"
            :loadingWords="item.loadingWords || loadingWords"
            :isLoadingError="item.status === ChatStatus.FAIL"
            class="grid-item cursor-pointer !rounded-8px"
            :type="item.type || 'video'"
            :finishLoad="finishLoad"
            ref="mediaContainer"
            @after-mounted="calcStyle(index)"
            @click="handleClick(item)"
        >
            <slot :row="item"></slot>
        </ImageVideoLoading>
    </div>
</template>
<script setup lang="ts">
import { ChatStatus } from '@/apis/publicBeta/api';
import ImageVideoLoading from './ImageVideoLoading.vue';

// 参数说明
// fileList 所有的文件list
// gap 是每个盒子的横向和纵向间距 最好是10的整数倍
// gridRowValue 拆分块大小，越小性能要求越高
// colWidth 盒子宽度
// colNum 展示列数
// 页面展示列数根据外层盒子的宽度以及每个盒子的宽度计算所得
// 文件加载文字
const mediaContainer = ref();
const finishLoad = (gridInstance: any, fileInstance: { videoWidth: any; videoHeight: any; naturalWidth: any; naturalHeight: any }, type: string) => {
    // 如果没有给出文件的宽高，则给文件设置一个默认宽高，然后等加载文件之后再设置gird-item高度
    if (!gridInstance.value) return Promise.resolve(true);
    return nextTick(() => {
        if (type === 'img') {
            const { naturalWidth, naturalHeight } = fileInstance;
            const num = calculateSize({ width: naturalWidth, height: naturalHeight });
            gridInstance.value.style.height = num * __props.gridRowValue + 'px';
            gridInstance.value.style.gridRow = `span ${num + Math.round(__props.gap / __props.gridRowValue)}`;
        } else {
            const { videoWidth, videoHeight } = fileInstance;
            const num = calculateSize({ width: videoWidth, height: videoHeight });
            gridInstance.value.style.height = num * __props.gridRowValue + 'px';
            gridInstance.value.style.gridRow = `span ${num + Math.round(__props.gap / __props.gridRowValue)}`;
        }
    });
};
withDefaults(defineProps<{
    isAutoPlay?: boolean;
    isLoop?: boolean;
    isDisableMouseover?: boolean;
    fileList: any[];
    gap?: number;
    isLazy?: boolean;
    gridRowValue?: number;
    colNum?: number;
    controls?: boolean;
    loadingWords?: string;
    handleClick?: (...test: any[]) => unknown;
}>(), { fileList: [],gap: 20,gridRowValue: 10,isLazy: false,handleClick: () => undefined,colNum: 3, })

const wallFall = ref();
const { width } = useWindowSize();

// 计算元素高度
const calculateSize = (obj: { width: number; height: number }) => {
    // 减去滚动条宽度
    const eleWidth = (wallFall.value.offsetWidth - __props.gap * (__props.colNum - 1)) / __props.colNum;
    // const eleWidth = (width.value - 80 - gap * (colNum - 1)) / colNum;
    const transformHeight = (obj.height * eleWidth) / obj.width;
    return Math.round(transformHeight / __props.gridRowValue); // 返回每个模块按照实际展示高度分割gridRowValue数量
};
const calcStyle = async (index: number) => {
    await nextTick();
    const { gridInstance, item } = mediaContainer.value[index];
    if (item.ratio === 'img') {
        return;
    }
    if (item.status === ChatStatus.FINISH) {
        return;
    }
    const { offsetWidth } = gridInstance;
    const ratio = item.ratio || '3:2';
    const arr = ratio.split(':');

    const idealHeight = (offsetWidth / arr[0]) * arr[1];
    const num = calculateSize({ width: offsetWidth, height: idealHeight });
    gridInstance.style.height = num * __props.gridRowValue + 'px';
    gridInstance.style.gridRow = `span ${num + Math.round(__props.gap / __props.gridRowValue)}`;
};

onMounted(async () => {
    // 动态设置每个盒子的宽度
    wallFall.value.style['gridTemplateColumns'] = `repeat(${__props.colNum}, 1fr)`;
    wallFall.value.style['gridAutoRows'] = `10px`;
    wallFall.value.style['columnGap'] = `${__props.gap}px`;
});
</script>
<style lang="less" scoped>
.waterfall {
    display: grid;

    .grid-item {
        width: 100%;
        font-size: 2em;
    }
}
</style>
